import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterRestaurantPage() {
  return <ClusterPageTemplate clusterName="Restaurant" sectorName="Horeca & Hospitality" sectorSlug="horeca-hospitality" heroTitle="Website laten maken voor een restaurant" heroDescription="Een sfeervolle, razendsnelle website voor jouw restaurant. Wij bouwen websites die de smaak van jouw keuken online overbrengen en reserveringen stimuleren." websiteOnderdelen={[{
    icon: 'UtensilsIcon',
    title: 'Menukaart',
    description: 'Een prachtig vormgegeven, mobielvriendelijke menukaart die je zelf eenvoudig kunt aanpassen bij een nieuw seizoen.'
  }, {
    icon: 'CameraIcon',
    title: 'Sfeerimpressie',
    description: "Grote, hoogwaardige foto's van je gerechten en het interieur om gasten direct te verleiden."
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Reserveren',
    description: 'Een opvallende, altijd zichtbare reserveerknop die naadloos linkt naar jouw reserveringssysteem.'
  }, {
    icon: 'MapPinIcon',
    title: 'Praktische info',
    description: 'Openingstijden, routebeschrijving, parkeerinformatie en contactgegevens direct vindbaar.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Reserveringssysteem',
    description: 'Integratie met systemen zoals TheFork, Formitable, GuestHouse of Resengo.'
  }, {
    icon: 'StarIcon',
    title: 'Google Reviews',
    description: 'Automatische weergave van je beste en nieuwste gastbeoordelingen om social proof te bieden.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Optimalisatie zodat je bovenaan staat als mensen zoeken naar 'uit eten in [jouw stad]'."
  }]} siblingClusters={[{
    name: 'Hotel & B&B',
    slug: 'hotel-bb'
  }, {
    name: 'Café & Lunchroom',
    slug: 'cafe-lunchroom'
  }, {
    name: 'Afhaal & Bezorg',
    slug: 'afhaal-bezorg'
  }]} faqs={[{
    q: 'Kan ik zelf de menukaart aanpassen?',
    a: 'Ja, we bouwen een speciaal, gebruiksvriendelijk menu-systeem in WordPress. Hiermee kun je heel makkelijk prijzen aanpassen, gerechten toevoegen of een heel nieuw seizoensmenu online zetten.'
  }, {
    q: 'Werkt de website goed op mobiele telefoons?',
    a: 'Absoluut. Meer dan 80% van de restaurant-zoekopdrachten gebeurt op mobiel (vaak onderweg). We zorgen dat de menukaart en de reserveerknop perfect werken op elk scherm.'
  }, {
    q: 'Wat kost een website voor een restaurant?',
    a: 'Een professionele restaurantwebsite start vanaf €1.500. Dit is inclusief het inrichten van je eerste menukaart en het koppelen van je reserveringssysteem.'
  }, {
    q: 'Koppelen jullie met Formitable of TheFork?',
    a: 'Zeker. We kunnen de widgets van vrijwel alle bekende horeca-reserveringssystemen naadloos integreren in het design van de website.'
  }]} data-id="element-1091" />;
}